module.exports = __webpack_public_path__ + "static/media/f5.30bbd166.jpeg";